import React from 'react';
import PropTypes from 'prop-types';

import QuoteSOVButton from './quoteSOVButtons';

import {
  DueMonthlyWrapper,
  DueNowText,
  Amount,
  Title,
  ButtonsWrapper
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Mobile = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmitForApproval,
  hidePricing,
  isQuoteApproved
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      DUE_NOW,
      BEFORE_TAXES,
      DOWNLOAD_THE_QUOTE,
      PROCEED_WITH_THE_ORDER,
      saveAndContinueLater,
      sendToSRT,
      submitForApproval,
      continueButton
    }
  } = localizedStrings;
  return (
    <div id="footer-low">
      {!hidePricing && (
        <>
          <DueMonthlyWrapper>
            <DueNowText>
              <span className="frg-body-font-14px color-white">
                {DUE_MONTHLY}
              </span>
              <Title>{BEFORE_TAXES}</Title>
              <span className="frg-body-font-14px color-white">{DUE_NOW}</span>
              <Title>{BEFORE_TAXES}</Title>
            </DueNowText>

            <Amount>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-monthly-total-low">{dueMonthly}</div>
              </span>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-now-total-low">{dueNow}</div>
              </span>
            </Amount>
          </DueMonthlyWrapper>
        </>
      )}

      {isOrderFulfillmentTeam ? (
        <QuoteSOVButton
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          onDownloadClick={onDownloadClick}
          onProceedClick={onProceedClick}
          onValidateForm={onValidateForm}
        />
      ) : (
        <ButtonsWrapper>
          {isFormValidated && !isVBP && (
            <button
              type="button"
              onClick={e => onDownloadClick(e)}
              className="frg-button color-purple"
            >
              {DOWNLOAD_THE_QUOTE}
            </button>
          )}
          {!isSendToSRT && !isVBP && isFormValidated && (
            <button
              type="button"
              onClick={e => onProceedClick(e)}
              className="frg-button color-green"
            >
              {PROCEED_WITH_THE_ORDER}
            </button>
          )}
          {isSendToSRT && !isVBP && isFormValidated && (
            <button
              type="button"
              onClick={e => onSendToSRT(e)}
              className="frg-button color-purple"
            >
              <span>{sendToSRT}</span>
            </button>
          )}
          {!isFormValidated && !isVBP && (
            <button
              type="button"
              onClick={e => onSaveAndExit(e)}
              className="frg-button color-green"
              disabled={!isFormTouched && !isQuoteApproved}
            >
              <span>{saveAndContinueLater}</span>
            </button>
          )}
          {!isFormValidated && !isVBP && (
            <button
              type="button"
              onClick={e => onValidateForm(e)}
              className="frg-button color-purple"
              disabled={!isFormTouched && !isQuoteApproved}
            >
              <span>{continueButton}</span>
            </button>
          )}
          {isFormValidated && isVBP && !isSalesSupport && (
            <button
              type="button"
              onClick={e => onSubmitForApproval(e)}
              className="frg-button color-green"
            >
              <span>{submitForApproval}</span>
            </button>
          )}
        </ButtonsWrapper>
      )}
    </div>
  );
};

Mobile.propTypes = {
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isVBP: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSubmitForApproval: PropTypes.func.isRequired,
  isQuoteApproved: PropTypes.bool.isRequired
};

export default Mobile;
